// Utility functions for admin access checking

export interface User {
  isAdmin?: boolean;
  role?: string;
  email?: string;
}

/**
 * Check if user is any type of admin
 * Includes: isAdmin flag, role === 'admin', or main admin email
 */
export const isAnyAdmin = (user?: User | null): boolean => {
  if (!user) return false;
  
  return user.isAdmin === true || 
         user.role === 'admin' || 
         user.email === 'jonp4208@gmail.com';
};

/**
 * Check if user is the main system admin (Jonathon Pope)
 */
export const isMainAdmin = (user?: User | null): boolean => {
  if (!user) return false;
  return user.email === 'jonp4208@gmail.com';
};

/**
 * Check if user is a store admin (isAdmin flag or admin role)
 */
export const isStoreAdmin = (user?: User | null): boolean => {
  if (!user) return false;
  return user.isAdmin === true || user.role === 'admin';
};

/**
 * Get admin type for display purposes
 */
export const getAdminType = (user?: User | null): string | null => {
  if (!user) return null;
  
  if (user.email === 'jonp4208@gmail.com') return 'System Admin';
  if (user.isAdmin || user.role === 'admin') return 'Store Admin';
  
  return null;
};
